import {
  Box,
  Text,
  Divider,
  Flex,
  Button,
  useMantineTheme,
} from "@mantine/core";
import { useAuth } from "../../context/auth";
import { formatCurrency } from "../../utils/currency";
import { useTranslation } from "react-i18next";

interface IProps {
  isLoading: boolean;
  isFree: boolean;
}

export const PaymentSummary = ({ isLoading, isFree }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { interest } = useAuth();
  const selectedInterest = interest.filter((item) => item.selected);

  const totalPrice = selectedInterest.reduce((acc, item) => {
    const selectedPlan = item.plan.find((p) => p.isSelected);
    return selectedPlan ? acc + selectedPlan.price : acc;
  }, 0);

  return (
    <Flex
      w="100%"
      maw={isFree ? "100%" : "396px"}
      gap="32px"
      p="24px"
      bg="basic.0"
      direction="column"
      style={{
        borderRadius: "12px",
        boxShadow: isFree ? "none" : "0px 10px 40px rgba(0, 0, 0, 0.05)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <Text
          sx={{
            color: theme.colors.basic[5],
            textAlign: "left",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "16px",
            lineHeight: "155%",
            fontWeight: 600,
          }}
        >
          {t("marketplace.comprar_serviços.purchase_step_3.resume")}
        </Text>
        {selectedInterest.map((item, index) => {
          const selectedPlan = item.plan.find((p) => p.isSelected);

          return (
            <Flex
              key={index}
              gap="24px"
              w={"100%"}
              align={"center"}
              justify={"space-between"}
            >
              <Text color={theme.colors.basic[5]} fz="16px" fw={500} lh="16px">
                {t("marketplace.comprar_serviços.purchase_step_3.product")}{" "}
                {index + 1}
              </Text>
              <Flex gap="6px" align={"end"} justify={"end"}>
                {!!selectedPlan?.qty_of_installments &&
                selectedPlan.qty_of_installments > 0 ? (
                  <Text
                    color={theme.colors.basic[4]}
                    fw={500}
                    fz="12px"
                    lh={"16px"}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {selectedPlan?.qty_of_installments}{" "}
                    {t("marketplace.comprar_serviços.purchase_step_3.x_of")}
                  </Text>
                ) : null}
                <Text
                  color={theme.colors.basic[5]}
                  fz="16px"
                  fw={500}
                  lh="16px"
                  tt="uppercase"
                >
                  {!!selectedPlan?.price
                    ? selectedPlan.qty_of_installments > 0
                      ? formatCurrency(
                          selectedPlan.price / selectedPlan.qty_of_installments
                        )
                      : formatCurrency(selectedPlan?.price)
                    : t("marketplace.comprar_serviços.purchase_step_3.free")}
                </Text>
              </Flex>
            </Flex>
          );
        })}
        <Divider w={"100%"} color="basic.2" />
        {isFree ? null : (
          <Flex
            bg={theme.colors.primaryOpacity[2]}
            p="18px 12px"
            w="100%"
            justify={"space-between"}
            align={"center"}
            sx={{ borderRadius: "8px" }}
          >
            <Text
              color={theme.colors.basic[5]}
              tt="uppercase"
              fz="12px"
              fw={500}
              lh="12px"
            >
              {t("marketplace.comprar_serviços.purchase_step_3.credit_card")}
            </Text>
            <Text color={theme.colors.primary[2]} fz="20px" fw={600} lh="31px">
              {formatCurrency(totalPrice)}
            </Text>
          </Flex>
        )}
      </Box>
      <Button fullWidth variant="primary" type="submit" loading={isLoading}>
        {t("marketplace.comprar_serviços.purchase_step_3.finish_payment")}
      </Button>
    </Flex>
  );
};
